export const TOGGLE_WIDGET_NAMES = {
  news: 'zprávy',
  video: 'video',
  woman: 'Ženu',
  sport: 'sport',
  finance: 'finance',
  exchange: 'kurzy',
  cars: 'auta'
}
